import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import WorkflowMapPopup from "../../components/WorkflowMapPopup";
import { SendReminder, getFilterCandidates, getReminderStatus, loadCandidatesByFilter, reminderSent } from "../store/candidate";
import { getAlert } from "../../services/appAlerts";
import { getFilterAllSubcontractors, loadSubcontractorsByFilter } from "../store/subcontractor";
import { useNavigate } from "react-router-dom";
import { getFilterAllRecruiters, loadRecruitersByFilter } from "../store/recruiter";

export default function ApplicationInfo(props) {
    const { procType, app, candidate: item, currentTask, appType } = props;
    const [workflowShowHide, setWorkflowShowHide] = useState(false);
    const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);
    const [performerdata, setPerformerdata] = useState({});

    const remiderStatusSelector = useSelector(getReminderStatus);
    const filterAllRecruiters = useSelector(getFilterAllRecruiters);
    const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);
    const filterAllCandidates = useSelector(getFilterCandidates);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleRemainder = (id) => {
        dispatch(SendReminder(id));
    };

    useEffect(() => {
        var frmBody = new FormData();
        frmBody.append("name", "");
        frmBody.append("email", "");
        if (remiderStatusSelector === "success") {
            getAlert("", "Reminder Sent Successfully", "success");
            if (item) {
                const currentObj = item;
                if (currentObj?.partnerType === "Sub-Contractors") {
                    frmBody.append("id", currentObj?.fuid);
                    frmBody.append("type", "Sub-Contractors");
                    dispatch(loadSubcontractorsByFilter(frmBody));
                }
                else if (currentObj?.partnerType === "Recruiter") {
                    frmBody.append("id", currentObj?.fuid);
                    frmBody.append("type", "Recruiter");
                    dispatch(loadSubcontractorsByFilter(frmBody));
                } else {
                    frmBody.append("id", currentObj?.id);
                    frmBody.append("entity", "");
                    frmBody.append("filterType", "single");
                    frmBody.append("type", "candidate");
                    dispatch(loadCandidatesByFilter(frmBody));
                }
            }
            dispatch(reminderSent());
        }
    }, [remiderStatusSelector]);

    useEffect(() => {
        var frmBody = new FormData();
        frmBody.append("name", "");
        frmBody.append("email", "");
        if (item) {
            const currentObj = item;
            if (currentObj?.partnerType === "Sub-Contractors") {
                frmBody.append("id", currentObj?.fuid);
                frmBody.append("type", "Sub-Contractors");
                dispatch(loadSubcontractorsByFilter(frmBody));
            }
            else if (currentObj?.partnerType === "Recruiter") {
                frmBody.append("id", currentObj?.fuid);
                frmBody.append("type", "Recruiter");
                dispatch(loadSubcontractorsByFilter(frmBody));
            } else {
                frmBody.append("id", currentObj?.id);
                frmBody.append("entity", "");
                frmBody.append("filterType", "single");
                frmBody.append("type", "candidate");
                dispatch(loadCandidatesByFilter(frmBody));
            }
        }
    }, []);

    useEffect(() => {
        setPerformerdata(filterAllRecruiters[0])
    }, [filterAllRecruiters])

    useEffect(() => {
        setPerformerdata(filterAllSubcontractors[0])
    }, [filterAllSubcontractors])

    useEffect(() => {
        setPerformerdata(filterAllCandidates[0])
    }, [filterAllCandidates])

    const handleViewApplication = () => {
        // to={{
        //     pathname: "/ApplicationSummary",
        //     state: { task: app, viewType: "view" },
        // }}
        navigate("/ApplicationSummary",
            {
                state: {
                    task: app,
                    viewType: "view",
                    appType: appType,
                    applicant: item,
                }
            })
    }

    const handleWorkflowModalShowHide = (obj) => {
        setWorkflowShowHide(!workflowShowHide);
    };

    const handleRemainderMessage = () => {
        setRemainderMsgShowHide(!remainderMsgShowHide);
    };

    return (
        <React.Fragment>
            <div className="border border-top-0 p-2 bg-white">
                <div className="d-flex flex-wrap align-items-center">
                    <div className="mr-5">App ID : {app.ciid}</div>

                    <div className="mr-3">
                        <button onClick={handleViewApplication} className="btn btn-sm btn-link p-0">
                            Onboarding Form
                        </button>
                        <br />
                        <Moment format="MMM Do YYYY">{app.addedDateTime}</Moment>
                        <br />
                        <Moment format="h:mm a">{app.addedDateTime}</Moment>
                    </div>

                    <div className="mr-3">
                        {!app?.appSubmitted ? (
                            <>
                                <button className="btn btn-sm btn-link p-0">Application Incomplete</button>
                                <br />
                                <button
                                    className="btn btn-sm btn-link p-0 text-underline"
                                    onClick={() => handleRemainder(performerdata.id)}
                                >
                                    Send Reminder
                                </button>
                                <button
                                    className="btn btn-sm btn-link p-0 text-underline"
                                    title="View message"
                                    onClick={handleRemainderMessage}
                                >
                                    <span className="badge badge-warning rounded-0 text-red">
                                        <i className="fa fa-envelope mr-1" aria-hidden="true"></i>
                                        {performerdata?.registrationType === "candidate"
                                            ? performerdata?.msgAlertCount ?? 0
                                            : performerdata?.contact1?.msgAlertCount ?? 0}
                                    </span>
                                </button>
                            </>
                        ) : (
                            <span>
                                <i className="fa fa-arrow-right mr-1" aria-hidden="true"></i> Review {app.status && " Completed"}
                            </span>
                        )}
                    </div>

                    <div className="mr-3">
                        {app.status === 1 && <button className="btn btn-sm btn-link p-0">Approved</button>}
                        {app.status === 0 && <button className="btn btn-sm btn-link p-0">Denied</button>}
                    </div>
                </div>
            </div>

            <WorkflowMapPopup
                workflowShowHide={workflowShowHide}
                handleWorkflowModalShowHide={handleWorkflowModalShowHide}
                selectedObj={currentTask}
            ></WorkflowMapPopup>
        </React.Fragment>
    )
}